import components from '../../common/_components';
import { _reflow } from '../../common/_core';
import { _on, _onTransitionEnd } from '../../common/_events';
import Cookies from '../../vendors.theme/_cookies';
import './promo-christmas.scss';

const COOKIE_NAME = 'PROMO_CHRISTMAS_HIDDEN';

const blockName = 'promo-christmas';
const componentsList = [];

let hasHandlerAttached = false;

components.add(`js-${blockName}`, (el) => {
    if (!hasHandlerAttached) {
        hasHandlerAttached = true;

        _on(document, 'click', `.js-${blockName}__close`, (e) => {
            Cookies.set(COOKIE_NAME, 'true', {
                expires: 5,
                path: '/',
            });

            _onTransitionEnd(componentsList[0], () => {
                componentsList.forEach((componentEl) => {
                    componentEl.parentNode.removeChild(componentEl);
                });
            });

            componentsList.forEach((componentEl) => {
                componentEl.style.height = `${componentEl.offsetHeight}px`;
                componentEl.classList.add('animating');

                _reflow(componentEl);
                componentEl.style.height = '0px';
            });

            e.preventDefault();
        }, { once: true, passive: true });
    }

    componentsList.push(el);
});
